import { For, Show } from 'solid-js';
import { insightParagraphs } from '@domain/openings/insights';
import { gameStore } from '@state/gameStore';
import './OpeningInsight.css';

export function spokenOpeningNotes(name: string | null | undefined): string[] {
  return name ? [name, ...insightParagraphs(name)] : [];
}

export function OpeningInsight(props: { reading?: number | null }) {
  const name = () => gameStore.loadedOpeningName;
  const paragraphs = () => {
    const n = name();
    return n ? insightParagraphs(n) : [];
  };

  return (
    <Show when={name()}>
      <article class="opening-insight" aria-label="Opening notes">
        <For each={paragraphs()}>
          {(p, i) => (
            <p classList={{ 'opening-insight__reading': props.reading === i() + 1 }}>{p}</p>
          )}
        </For>
      </article>
    </Show>
  );
}
